import request from "@/plugins/axios";

export function createAppRelease(data) {
    let config = {
        headers: {
            'Content-Type': 'application/json'
        },
        transformRequest: [function (data) {
            data = JSON.stringify(data)
            return data
        }]
    }
    return request.post("/release", data, config)
}

export function findAllCheckingReleaseByAppId(appId) {
    let params = new URLSearchParams()
    params.append("appId",appId)
    params.append("released",false.toString())
    return request.get("/releases/appId", {params})
}

export function findAllPassReleaseByAppId(appId) {
    let params = new URLSearchParams()
    params.append("appId",appId)
    params.append("pageSize", 100)
    params.append("released",true.toString())
    return request.get("/releases/appId", {params})
}

export function auditAppRelease(releaseId) {
    return request.put(`/release/audit/${releaseId}`)
}

export function deleteAppRelease(releaseId) {
    return request.delete(`/release/r/${releaseId}`)
}

export function findLatelyRelease(appId) {
    let params = new  URLSearchParams()
    params.append("appId",appId)
    return request.get(`/release`,{params})
}
